/**
 * Find Account API
 * 아이디/비밀번호 찾기 관련 API 호출 함수
 */

import { apiClient } from '../../../core/api/client';
import { FindAccountRequest, FindAccountResponse } from '../types/findAccount';

const BASE_PATH = '/api/v1/mob/login';

/**
 * 아이디/비밀번호 찾기 API
 * POST /api/v1/mob/login/find-account
 * @param params 찾기 요청 파라미터 (type: 'id' | 'password', name?, userId?, email)
 * @returns 찾기 응답
 */
export const findAccount = async (params: FindAccountRequest): Promise<FindAccountResponse> => {
    const response = await apiClient.post<FindAccountResponse>(
        `${BASE_PATH}/find-account`,
        params
    );
    return response.data;
};

